export enum Product {
  STAR = 'star',
  STAR_V4 = 'starv4',
  STAR_V5 = 'starv5',
}
